/* Discount code entry for the cart drawer and cart page.
   Uses the Cart AJAX API discount parameter on /cart/update.js. */
(function () {
  if (window.customElements.get('cart-discount-form')) return;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function postDiscount(codes) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    });
  }

  class CartDiscountForm extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.list = this.querySelector('[data-discount-list]');
      this.toggle = this.querySelector('[data-discount-toggle]');
      this.panel = this.querySelector('[data-discount-panel]');
      this.input = this.querySelector('[data-discount-input]');
      this.applyBtn = this.querySelector('[data-discount-apply]');
      this.message = this.querySelector('[data-discount-message]');
      this.template = this.querySelector('[data-discount-template]');

      this.toggle.addEventListener('click', this.togglePanel.bind(this, null));
      this.applyBtn.addEventListener('click', this.apply.bind(this));

      this.input.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Enter') return;
        evt.preventDefault();
        evt.stopPropagation();
        this.apply();
      }.bind(this));

      this.list.addEventListener('click', function (evt) {
        var btn = evt.target.closest('[data-discount-remove]');
        if (!btn) return;
        evt.preventDefault();
        this.submit(this.codes.filter(function (c) {
          return c.toLowerCase() !== String(btn.dataset.code || '').toLowerCase();
        }), null);
      }.bind(this));

      this.syncHandler = this.sync.bind(this);
      document.addEventListener('on:cart:after-merge', this.syncHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('on:cart:after-merge', this.syncHandler);
    }

    get codes() {
      return Array.prototype.slice
        .call(this.list.querySelectorAll('[data-discount-remove]'))
        .map(function (btn) { return btn.dataset.code; })
        .filter(Boolean);
    }

    togglePanel(force) {
      var open = typeof force === 'boolean' ? force : this.panel.hasAttribute('hidden');
      if (open) {
        this.panel.removeAttribute('hidden');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.input.focus();
      } else {
        this.panel.setAttribute('hidden', '');
        this.toggle.setAttribute('aria-expanded', 'false');
      }
    }

    apply() {
      var code = (this.input.value || '').trim();
      if (!code) {
        this.input.focus();
        return;
      }
      var already = this.codes.some(function (c) {
        return c.toLowerCase() === code.toLowerCase();
      });
      if (already) {
        this.setMessage('That code is already applied.', 'error');
        return;
      }
      this.submit(this.codes.concat([code]), code);
    }

    submit(codes, addedCode) {
      var self = this;
      self.setBusy(true);
      self.setMessage('', null);

      return postDiscount(codes)
        .then(function (cart) {
          var accepted = self.applicableCodes(cart);
          if (!addedCode) {
            self.render(accepted);
            self.refreshCart();
            return;
          }
          var ok = accepted.some(function (c) {
            return c.toLowerCase() === addedCode.toLowerCase();
          });
          if (ok) {
            self.input.value = '';
            self.togglePanel(false);
            self.render(accepted);
            self.setMessage(addedCode.toUpperCase() + ' applied.', 'success');
            self.refreshCart();
            return;
          }
          return postDiscount(accepted).then(function (cleanCart) {
            self.render(self.applicableCodes(cleanCart));
            self.setMessage('That code is not valid for the items in your cart.', 'error');
            self.refreshCart();
          });
        })
        .catch(function () {
          self.setMessage('We could not apply that code. Please try again.', 'error');
        })
        .then(function () {
          self.setBusy(false);
        });
    }

    sync() {
      if (this.busy) return;
      var self = this;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (cart) self.render(self.applicableCodes(cart));
        })
        .catch(function () { /* leave current state in place */ });
    }

    applicableCodes(cart) {
      if (!cart) return [];
      var fromCodes = (cart.discount_codes || [])
        .filter(function (d) { return d && d.code && d.applicable !== false; })
        .map(function (d) { return d.code; });
      if (fromCodes.length) return fromCodes;
      return (cart.cart_level_discount_applications || [])
        .filter(function (d) { return d.type === 'discount_code'; })
        .map(function (d) { return d.title; });
    }

    render(codes) {
      this.list.innerHTML = '';
      var tpl = this.template;
      var list = this.list;
      codes.forEach(function (code) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        node.querySelector('.cart-discount-form__code-text').textContent = code;
        var btn = node.querySelector('[data-discount-remove]');
        btn.dataset.code = code;
        btn.querySelector('.visually-hidden').textContent = 'Remove discount code ' + code;
        list.appendChild(node);
      });
      if (codes.length) {
        this.list.removeAttribute('hidden');
      } else {
        this.list.setAttribute('hidden', '');
      }
    }

    refreshCart() {
      var refreshed = false;
      document.querySelectorAll('cart-form').forEach(function (form) {
        if (typeof form.refresh === 'function') {
          form.refresh();
          refreshed = true;
        }
      });
      if (!refreshed) window.location.reload();
    }

    setBusy(state) {
      this.busy = state;
      this.classList.toggle('is-busy', !!state);
    }

    setMessage(text, type) {
      this.message.textContent = text || '';
      this.message.classList.toggle('cart-discount-form__message--error', type === 'error');
    }
  }

  window.customElements.define('cart-discount-form', CartDiscountForm);
})();
